import { useContext } from 'react';

import { DocumentContext } from '../component';

export const useDoc = () => {
  const { doc } = useContext(DocumentContext);

  if (doc !== null) {
    return doc;
  } else {
    throw new Error(
      'Could not retrieve a document. Please wrap in a DocumentProvider.'
    );
  }
};
